import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, '') ?? '';
const apiPrefix = `${baseUrl}/api`;

// Ответ на этот запрос разбирает сам App: 401 здесь — обычное «ещё не вошёл», а не конец сессии.
export const SESSION_CHECK_PATH = '/auth/me';

const apiClient = axios.create({
  baseURL: apiPrefix,
  timeout: 15000,
  // Сессия — в HttpOnly-cookie. На своём адресе браузер приложит её и так, флаг нужен, когда api на другом.
  withCredentials: true,
  paramsSerializer: (params) => {
    const search = new URLSearchParams();

    Object.entries(params ?? {}).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        return;
      }

      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item !== null && item !== undefined) {
            search.append(key, item);
          }
        });
        return;
      }

      search.append(key, value);
    });

    return search.toString();
  }
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.config?.url === SESSION_CHECK_PATH) {
      throw error;
    }

    if (error?.response?.status === 401) {
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    const message = error?.response?.data?.message || error.message;
    console.error('API request failed:', message, error);
    throw error;
  }
);

export default apiClient;
